import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';

@Component({
  selector: 'app-winners',
  templateUrl: './winners.component.html',
  styleUrls: ['./winners.component.scss']
})
export class WinnersComponent implements OnInit {
  data: any = null;
  feed: any = [];
  constructor(public http: Http) { this.getSheetData()}

  public getSheetData() {
    const sheetId = '1fSN12-NxZCIGb4s11y-9cw2YN6fNUZteDjGsstBKa5w';
    const url = `https://spreadsheets.google.com/feeds/list/${sheetId}/od6/public/values?alt=json`;
    this.http.get(url, {
     
    })
    .subscribe(
      data => {
        console.log('sheet data')
        console.log(data);
        this.feed = data['feed']
      },
      error => {
      }
    );
}
  ngOnInit() {
  }

}
